<div class="grid">
  <div class="col-12 md:ml-5 py-4">
    <div class="flex-auto flex-wrap justify-content-center">
      <form [formGroup]="patientInfoForm">
        <div class="md:flex col-12 ml-2">
          <h5>{{ 'Patient_Info.PrimaryPatient' | translate }}</h5>
        </div>
        <div class="md:flex col-12">
          <div class="sm:col-12 md:col-5 flex align-items-center">
            <span class="label asterisk">{{ 'Patient_Info.Patient_First_Name' | translate }} </span>
          </div>
          <div class="sm:col-12 md:col-7">
            <input
              pInputText
              id="firstName"
              aria-describedby="firstName-help"
              formControlName="firstName"
              class="w-full" />
            @if (
              patientInfoForm.controls.firstName.invalid &&
              (patientInfoForm.controls.firstName.dirty || patientInfoForm.controls.firstName.touched)
            ) {
              <div>
                @if (patientInfoForm.controls.firstName.hasError('required')) {
                  <small class="text-danger">
                    <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{
                      'Patient_Info.Patient_First_Name_Required' | translate
                    }}
                  </small>
                }
                @if (patientInfoForm.controls.firstName.hasError('maxLengthExceeded')) {
                  <small class="text-danger">
                    <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{ exceedTestLimit }}
                  </small>
                }
                @if (patientInfoForm.controls.firstName.hasError('invalidTextInput')) {
                  <small class="text-danger">
                    <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{ allowCharecter }}
                  </small>
                }
              </div>
            }
          </div>
        </div>
        <div class="md:flex col-12">
          <div class="sm:col-12 md:col-5 flex align-items-center">
            <span class="label asterisk">{{ 'Patient_Info.Patient_Last_Name' | translate }} </span>
          </div>
          <div class="sm:col-12 md:col-7">
            <input
              pInputText
              id="lastName"
              aria-describedby="lastName-help"
              formControlName="lastName"
              class="w-full" />
            @if (
              patientInfoForm.controls.lastName.invalid &&
              (patientInfoForm.controls.lastName.dirty || patientInfoForm.controls.lastName.touched)
            ) {
              <div>
                @if (patientInfoForm.controls.lastName.hasError('required')) {
                  <small class="text-danger">
                    <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{
                      'Patient_Info.Patient_Last_Name_Required' | translate
                    }}
                  </small>
                }
                @if (patientInfoForm.controls.lastName.hasError('maxLengthExceeded')) {
                  <small class="text-danger">
                    <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{ exceedTestLimit }}
                  </small>
                }
                @if (patientInfoForm.controls.lastName.hasError('invalidTextInput')) {
                  <small class="text-danger">
                    <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{ allowCharecter }}
                  </small>
                }
              </div>
            }
          </div>
        </div>
        <div class="md:flex col-12">
          <div class="sm:col-12 md:col-5 flex align-items-center">
            <span class="label asterisk">{{ 'Patient_Info.Patient_DOB' | translate }} </span>
          </div>
          <div class="sm:col-12 md:col-7">
            <app-masked-calendar id="dob" formControlName="dob" [maxDate]="maxDate" />
            @if (
              patientInfoForm.controls.dob.invalid &&
              (patientInfoForm.controls.dob.dirty || patientInfoForm.controls.dob.touched)
            ) {
              <div>
                @if (patientInfoForm.controls.dob.hasError('required')) {
                  <small class="text-danger">
                    <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{
                      'Patient_Info.Patient_DOB_Required' | translate
                    }}
                  </small>
                }
                @if (patientInfoForm.controls.dob.hasError('maxdate')) {
                  <small class="text-danger">
                    <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{
                      'Patient_Info.PatientDOBGreaterThanToday' | translate
                    }}
                  </small>
                }
              </div>
            }
          </div>
        </div>
        <div class="md:flex col-12">
          <div class="sm:col-12 md:col-5 flex align-items-center">
            <span class="label asterisk">{{ 'Patient_Info.Patient_Gender' | translate }} </span>
          </div>
          <div class="sm:col-12 md:col-7">
            <p-select id="gender"
              [options]="genderOptions"
              formControlName="gender"
              optionLabel="label"
              optionValue="value"
              aria-describedby="gender-help"
              class="w-full" />
            @if (
              patientInfoForm.controls.gender.invalid &&
              (patientInfoForm.controls.gender.dirty || patientInfoForm.controls.gender.touched)
            ) {
              <div>
                @if (patientInfoForm.controls.gender.hasError('required')) {
                  <small class="text-danger">
                    <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{
                      'Patient_Info.Patient_Gender' | translate
                    }}&nbsp;{{ 'DynamicForm.IsRequired' | translate }}
                  </small>
                }
                @if (patientInfoForm.controls.lastName.hasError('maxLengthExceeded')) {
                  <small class="text-danger">
                    <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{ exceedTestLimit }}
                  </small>
                }
                @if (patientInfoForm.controls.lastName.hasError('invalidTextInput')) {
                  <small class="text-danger">
                    <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{ allowCharecter }}
                  </small>
                }
              </div>
            }
          </div>
        </div>
        <div class="md:flex col-12">
          <div class="sm:col-12 md:col-5 flex align-items-center">
            <span class="label">{{ 'Patient_Info.Patient_ID' | translate }} </span>
          </div>
          <div class="sm:col-12 md:col-7">
            <input
              pInputText
              id="patientId"
              aria-describedby="patientId-help"
              formControlName="patientId"
              class="w-full" />
            @if (
              patientInfoForm.controls.patientId.invalid &&
              (patientInfoForm.controls.patientId.dirty || patientInfoForm.controls.patientId.touched)
            ) {
              <div>
                @if (patientInfoForm.controls.patientId.hasError('invalidDigitCharacterInput')) {
                  <small class="text-danger">
                    <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{ allowDigitChar }}
                  </small>
                }
              </div>
            }
          </div>
        </div>
        <div class="md:flex col-12">
          <div class="sm:col-12 md:col-5 flex align-items-center">
            <span class="label">{{ 'Patient_Info.Patient_Email' | translate }} </span>
          </div>
          <div class="sm:col-12 md:col-7">
            <input pInputText id="email" aria-describedby="email-help" formControlName="email" class="w-full" />
            @if (
              patientInfoForm.controls.email.invalid &&
              (patientInfoForm.controls.email.dirty || patientInfoForm.controls.email.touched)
            ) {
              <div>
                @if (patientInfoForm.controls.email.hasError('pattern')) {
                  <small class="text-danger">
                    <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i>
                    {{ 'Patient_Info.Patient_Invalid_Email' | translate }}
                  </small>
                }
              </div>
            }
          </div>
        </div>
        <div class="md:flex col-12">
          <div class="sm:col-12 md:col-5 flex align-items-center">
            <span class="label">
              {{ 'Patient_Info.Patient_Phone_No' | translate }}
            </span>
          </div>
          <div class="sm:col-12 md:col-7 flex">
            <div class="col-5 pl-0">
              <p-select id="countryCode"
                styleClass="w-full"
                formControlName="countryCode"
                [options]="(countries$ | async) ?? []"
                optionLabel="phoneNumberPrefixWithPlus"
                optionValue="phoneNumberPrefix"
                aria-describedby="country code"
                placeholder="{{ 'Order_Info.CountryCode' | translate }}"
                [required]="isRequired('countryCode')" />
              @if (
                patientInfoForm.controls.countryCode.touched &&
                patientInfoForm.controls.countryCode.hasError('required')
              ) {
                <small class="text-danger">
                  <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"> </i
                  >{{ 'Order_Info.CountryCodeIsRequired' | translate }}
                </small>
              }
            </div>
            <div class="col-7 ml-2">
              <input
                pInputText
                id="phoneNumber"
                aria-describedby="phone-help"
                formControlName="phoneNumber"
                placeholder="00-0000-0000"
                class="w-full"
                [required]="isRequired('phoneNumber')" />
              @if (
                patientInfoForm.controls.phoneNumber.touched &&
                patientInfoForm.controls.phoneNumber.hasError('required')
              ) {
                <small class="text-danger">
                  <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"> </i
                  >{{ 'Order_Info.PhoneIsRequired' | translate }}
                </small>
              }
              @if (
                patientInfoForm.controls.phoneNumber.touched &&
                !patientInfoForm.controls.phoneNumber.hasError('required') &&
                patientInfoForm.controls.phoneNumber.hasError('pattern')
              ) {
                <small class="text-danger">
                  <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"> </i
                  >{{ 'Order_Info.Phone_Number_Only' | translate }}
                </small>
              }
              @if (
                patientInfoForm.controls.phoneNumber.touched &&
                !patientInfoForm.controls.phoneNumber.hasError('required') &&
                (patientInfoForm.controls.phoneNumber.hasError('minlength') ||
                  patientInfoForm.controls.phoneNumber.hasError('maxlength')) &&
                !patientInfoForm.controls.phoneNumber.hasError('pattern')
              ) {
                <small class="text-danger">
                  <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"> </i
                  >{{ 'Patient_Info.Phone_No_Min_Max_Digit' | translate }}
                </small>
              }
            </div>
          </div>
        </div>
        <p-divider styleClass="p-divider-gray" />
        <div class="md:flex col-12">
          <div class="sm:col-12 md:col-5 flex align-items-center">
            <span class="label asterisk">{{ 'Patient_Info.Sample_Type' | translate }} </span>
          </div>
          <div class="sm:col-12 md:col-7">
            <p-select
              id="sampleType"
              styleClass="w-full"
              formControlName="sampleType"
              optionLabel="label"
              optionValue="id"
              [options]="(sampleTypes$ | async) ?? []"
              [filter]="true"
              filterBy="label"
              [showClear]="true"
              aria-describedby="sampleType-help"
              [placeholder]="'Patient_Info.Sample_Type' | translate"
              class="w-full">
              <ng-template let-item #sampleTypeItem>
                <div class="flex items-center gap-2">
                  <div [attr.data-testid]="item.name">{{ item.label }}</div>
                </div>
              </ng-template>
            </p-select>
            @if (
              patientInfoForm.controls.sampleType.invalid &&
              (patientInfoForm.controls.sampleType.dirty || patientInfoForm.controls.sampleType.touched)
            ) {
              <div>
                @if (patientInfoForm.controls.sampleType.hasError('required')) {
                  <small class="text-danger">
                    <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{
                      'Patient_Info.Sample_Type_Required' | translate
                    }}
                  </small>
                }
              </div>
            }
          </div>
        </div>
        <div class="md:flex col-12">
          <div class="sm:col-12 md:col-5 align-content-center">
            <span class="label asterisk">{{ 'Patient_Info.Sample_barcode_for_this_patient' | translate }} </span>
          </div>
          <div class="sm:col-12 md:col-7">
            <input pInputText id="barcode" aria-describedby="barcode-help" formControlName="barcode" class="w-full" />
            @if (patientInfoForm.controls.barcode.touched && patientInfoForm.controls.barcode.hasError('required')) {
              <small class="text-danger">
                {{ 'Patient_Info.BarcodeIsRequired' | translate }}
              </small>
            }
            @if (
              patientInfoForm.controls.barcode.touched &&
              !patientInfoForm.controls.barcode.hasError('required') &&
              patientInfoForm.controls.barcode.hasError('notUnique')
            ) {
              <small class="text-danger">
                {{ 'Patient_Info.DuplicateBarcodeError' | translate }}
              </small>
            }
          </div>
        </div>
        <div class="md:flex col-12">
          <div class="sm:col-12 md:col-5 flex align-items-center">
            <span class="label asterisk">{{ 'Patient_Info.Collection_date_of_the_sample' | translate }} </span>
          </div>
          <div class="sm:col-12 md:col-7">
            <app-masked-calendar id="sampleCollectionDate"
              formControlName="sampleCollectionDate"
              [maxDate]="maxDate" />
            @if (
              patientInfoForm.controls.sampleCollectionDate.invalid &&
              (patientInfoForm.controls.sampleCollectionDate.dirty ||
                patientInfoForm.controls.sampleCollectionDate.touched)
            ) {
              <div>
                @if (patientInfoForm.controls.sampleCollectionDate.hasError('required')) {
                  <small class="text-danger">
                    <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{
                      'Patient_Info.SampleCollectionDateIsRequired' | translate
                    }}
                  </small>
                }
                @if (patientInfoForm.controls.sampleCollectionDate.hasError('maxdate')) {
                  <small class="text-danger">
                    <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{
                      'Patient_Info.SampleCollectionDateGreaterThanToday' | translate
                    }}
                  </small>
                }
              </div>
            }
          </div>
        </div>

        <div formArrayName="relatedPatientInfo">
          @for (relatedPatient of relatedPatientForms.controls; track relatedPatient; let i = $index) {
            <div [formGroupName]="i" [id]="'relatedPatientInfo' + i">
              <div class="md:flex col-12 ml-2 mt-1">
                <h5>{{ 'Patient_Info.Patient' | translate }} {{ i + 2 }}</h5>
              </div>
              <div class="md:flex col-12 m-2 mt-1">
                @for (msg of messages; track msg) {
                  <p-message class="w-full" [closable]="true" [severity]="$any(msg.severity)" [icon]="msg.icon">
                    <div class="content-box">
                      <span class="summary-txt">{{ msg.severity }}</span>
                      <span>{{ msg.detail }}</span>
                    </div>
                  </p-message>
                }
              </div>
              <div class="md:flex col-12">
                <div class="sm:col-12 md:col-5 flex align-items-center">
                  <span class="label asterisk">{{ 'Patient_Info.Patient_First_Name' | translate }} </span>
                </div>
                <div class="sm:col-12 md:col-7">
                  <input
                    pInputText
                    [id]="'firstName' + i"
                    aria-describedby="firstName-help"
                    formControlName="firstName"
                    class="w-full" />
                  @if (
                    relatedPatient.get('firstName')?.invalid &&
                    (relatedPatient.get('firstName')?.dirty || relatedPatient.get('firstName')?.touched)
                  ) {
                    <div>
                      @if (relatedPatient.get('firstName')?.hasError('required')) {
                        <small class="text-danger">
                          <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{
                            'Patient_Info.Patient_First_Name_Required' | translate
                          }}
                        </small>
                      }
                      @if (relatedPatient.get('firstName')?.hasError('maxLengthExceeded')) {
                        <small class="text-danger">
                          <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{ exceedTestLimit }}
                        </small>
                      }
                      @if (relatedPatient.get('firstName')?.hasError('invalidTextInput')) {
                        <small class="text-danger">
                          <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{ allowCharecter }}
                        </small>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="md:flex col-12">
                <div class="sm:col-12 md:col-5 flex align-items-center">
                  <span class="label asterisk">{{ 'Patient_Info.Patient_Last_Name' | translate }} </span>
                </div>
                <div class="sm:col-12 md:col-7">
                  <input
                    pInputText
                    [id]="'lastName' + i"
                    aria-describedby="lastName-help"
                    formControlName="lastName"
                    class="w-full" />
                  @if (
                    relatedPatient.get('lastName')?.invalid &&
                    (relatedPatient.get('lastName')?.dirty || relatedPatient.get('lastName')?.touched)
                  ) {
                    <div>
                      @if (relatedPatient.get('lastName')?.hasError('required')) {
                        <small class="text-danger">
                          <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{
                            'Patient_Info.Patient_Last_Name_Required' | translate
                          }}
                        </small>
                      }
                      @if (relatedPatient.get('lastName')?.hasError('maxLengthExceeded')) {
                        <small class="text-danger">
                          <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{ exceedTestLimit }}
                        </small>
                      }
                      @if (relatedPatient.get('lastName')?.hasError('invalidTextInput')) {
                        <small class="text-danger">
                          <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{ allowCharecter }}
                        </small>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="md:flex col-12">
                <div class="sm:col-12 md:col-5 flex align-items-center">
                  <span class="label asterisk">{{ 'Patient_Info.Patient_DOB' | translate }} </span>
                </div>
                <div class="sm:col-12 md:col-7">
                  <app-masked-calendar [id]="'dob' + i" formControlName="dob" [maxDate]="maxDate" />
                  @if (
                    relatedPatient.get('dob')?.invalid &&
                    (relatedPatient.get('dob')?.dirty || relatedPatient.get('dob')?.touched)
                  ) {
                    <div>
                      @if (relatedPatient.get('dob')?.hasError('required')) {
                        <small class="text-danger">
                          <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{
                            'Patient_Info.Patient_DOB_Required' | translate
                          }}
                        </small>
                      }
                      @if (relatedPatient.get('dob')?.hasError('maxdate')) {
                        <small class="text-danger">
                          <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{
                            'Patient_Info.PatientDOBGreaterThanToday' | translate
                          }}
                        </small>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="md:flex col-12">
                <div class="sm:col-12 md:col-5 flex align-items-center">
                  <span class="label asterisk">{{ 'Patient_Info.RelatedPatient' | translate }} </span>
                </div>
                <div class="sm:col-12 md:col-7">
                  <p-select [id]="'patientRelationType' + i"
                    styleClass="w-full"
                    [options]="(patientRelationTypes$ | async) ?? []"
                    formControlName="patientRelationType"
                    optionLabel="name"
                    optionValue="id"
                    aria-describedby="patientRelationType-help"
                    [placeholder]="'Patient_Info.RelatedPatient' | translate" />
                  @if (
                    relatedPatient.get('patientRelationType')?.invalid &&
                    (relatedPatient.get('patientRelationType')?.dirty ||
                      relatedPatient.get('patientRelationType')?.touched)
                  ) {
                    <div>
                      @if (relatedPatient.get('patientRelationType')?.hasError('required')) {
                        <small class="text-danger">
                          <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{
                            'Patient_Info.RelatedPatientIsRequired' | translate
                          }}
                        </small>
                      }
                    </div>
                  }
                </div>
              </div>
              <p-divider styleClass="p-divider-gray" />
              <div class="md:flex col-12">
                <div class="sm:col-12 md:col-5 flex align-items-center">
                  <span class="label asterisk">{{ 'Patient_Info.Sample_Type' | translate }} </span>
                </div>
                <div class="sm:col-12 md:col-7">
                  <p-select
                    [id]="'sampleType' + i"
                    styleClass="w-full"
                    [options]="(sampleTypes$ | async) ?? []"
                    [filter]="true"
                    filterBy="label"
                    [showClear]="true"
                    formControlName="sampleType"
                    optionLabel="label"
                    optionValue="id"
                    aria-describedby="sampleType-help"
                    [placeholder]="'Patient_Info.Sample_Type' | translate">
                    <ng-template let-item #item>
                      <div class="flex items-center gap-2">
                        <div [attr.data-testid]="item.name">{{ item.label }}</div>
                      </div>
                    </ng-template>
                  </p-select>
                  @if (
                    relatedPatient.get('sampleType')?.invalid &&
                    (relatedPatient.get('sampleType')?.dirty || relatedPatient.get('sampleType')?.touched)
                  ) {
                    <div>
                      @if (relatedPatient.get('sampleType')?.hasError('required')) {
                        <small class="text-danger">
                          <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{
                            'Patient_Info.Sample_Type_Required' | translate
                          }}
                        </small>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="md:flex col-12">
                <div class="sm:col-12 md:col-5 align-content-center">
                  <span class="label asterisk">{{ 'Patient_Info.Sample_barcode_for_this_patient' | translate }} </span>
                </div>
                <div class="sm:col-12 md:col-7">
                  <input
                    pInputText
                    [id]="'barcode' + i"
                    aria-describedby="barcode-help"
                    formControlName="barcode"
                    class="w-full" />
                  @if (relatedPatient.get('barcode')?.touched && relatedPatient.get('barcode')?.hasError('required')) {
                    <small class="text-danger">
                      {{ 'Patient_Info.BarcodeIsRequired' | translate }}
                    </small>
                  }
                  @if (
                    relatedPatient.get('barcode')?.touched &&
                    !relatedPatient.get('barcode')?.hasError('required') &&
                    relatedPatient.get('barcode')?.hasError('notUnique')
                  ) {
                    <small class="text-danger">
                      {{ 'Patient_Info.DuplicateBarcodeError' | translate }}
                    </small>
                  }
                </div>
              </div>
              <div class="md:flex col-12">
                <div class="sm:col-12 md:col-5 flex align-items-center">
                  <span class="label asterisk">{{ 'Patient_Info.Collection_date_of_the_sample' | translate }} </span>
                </div>
                <div class="sm:col-12 md:col-7">
                  <app-masked-calendar [id]="'sampleCollectionDate' + i"
                    formControlName="sampleCollectionDate"
                    [maxDate]="maxDate" />
                  @if (
                    relatedPatient.get('sampleCollectionDate')?.invalid &&
                    (relatedPatient.get('sampleCollectionDate')?.dirty ||
                      relatedPatient.get('sampleCollectionDate')?.touched)
                  ) {
                    <div>
                      @if (relatedPatient.get('sampleCollectionDate')?.hasError('required')) {
                        <small class="text-danger">
                          <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{
                            'Patient_Info.SampleCollectionDateIsRequired' | translate
                          }}
                        </small>
                      }
                      @if (relatedPatient.get('sampleCollectionDate')?.hasError('maxdate')) {
                        <small class="text-danger">
                          <i class="pi pi-exclamation-circle" style="font-size: 0.8rem"></i> &nbsp;{{
                            'Patient_Info.SampleCollectionDateGreaterThanToday' | translate
                          }}
                        </small>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>

        <div class="col-12 mb-4 mt-4">
          <span class="ml-2">{{ 'NIPT.clinicalHistory.common.marksMandatoryFields.Label' | translate }}</span>
        </div>
      </form>
    </div>
  </div>
</div>
